import { useQuery } from '@tanstack/react-query';
import { getCatalogItems } from '../api';
import type { CatalogFilters } from '../types';

export const CATALOG_ITEMS_QUERY_KEY = 'catalogItems';

interface UseCatalogItemsOptions {
  filters?: CatalogFilters;
  enabled?: boolean;
}

/**
 * Hook for fetching catalog items with TanStack Query.
 */
export function useCatalogItems({
  filters,
  enabled = true,
}: UseCatalogItemsOptions = {}) {
  return useQuery({
    queryKey: [CATALOG_ITEMS_QUERY_KEY, filters],
    queryFn: () => getCatalogItems(filters),
    enabled,
    staleTime: 60_000,
    gcTime: 5 * 60 * 1000,
  });
}
